export default __webpack_public_path__ + "static/media/microflow_1.3c69ea90.png";